import { render, staticRenderFns } from "./AddBuy.vue?vue&type=template&id=02539d6c&scoped=true"
import script from "./AddBuy.vue?vue&type=script&lang=js"
export * from "./AddBuy.vue?vue&type=script&lang=js"
import style0 from "./AddBuy.vue?vue&type=style&index=0&id=02539d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02539d6c",
  null
  
)

export default component.exports